import Empty            from '@widesk-ui/components/Empty';
import View             from '@widesk-ui/components/View';
import React            from 'react';
import useDesignTokens  from '@/hooks/useDesignTokens';

/**
 * État vide d'une liste de la sidebar.
 *
 * Partagé par les trois listes — thèmes, points d'intérêts, types — qui montraient jusqu'ici trois
 * choses différentes : un message écrit pour les thèmes, le « Aucune donnée » d'antd pour les deux
 * autres. Trois listes côte à côte dans le même menu doivent se taire de la même façon.
 *
 * Deux lignes : ce qui manque, puis à quoi ça sert. La seconde est la seule utile — qui ouvre cette
 * liste voit déjà qu'elle est vide.
 *
 * Pas de bouton : les trois listes portent le leur en bas, toujours visible, y compris quand elles
 * sont vides.
 */
export default function ListEmptyState(props: { title: string; hint?: React.ReactNode; }) {
	const tokens = useDesignTokens();

	return (
		<Empty description={(
			<View gap={4} center>
				<View bold color={tokens.text.default}>{props.title}</View>

				{!!props.hint && (
					<View size="small" lineHeight={1.45} color={tokens.text.muted} style={{ maxWidth: 260 }}>
						{props.hint}
					</View>
				)}
			</View>
		)} />
	);
}
